import React from 'react';

import { Container, PaddingTop, CardDisplay } from './Styled';

import Text from 'components/Text';
import Card from 'components/common/Card';

import Theme from 'Theme';

export const NoMatch = ({ title, text }) => {
  return (
    <Container>
      <CardDisplay>
        <Card.Title color={Theme.brandColor}>{title}</Card.Title>
        <PaddingTop>
          <Text.Info>{text}</Text.Info>
        </PaddingTop>
      </CardDisplay>
    </Container>
  );
};

NoMatch.defaultProps = {
  removeMargin: false,
  title: 'Page Not Found',
  text:
    "We were unable to find the page you're looking for. The page could have been removed or you may not have the appropriate permissions."
};

export default NoMatch;
